/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
import AWS from 'aws-sdk';
import { toast } from 'react-toastify';
import Auth from '../../utils/Auth';
import { getS3Region } from '../../utils/helpers';

class S3Select {
// eslint-disable-next-line class-methods-use-this
  async getAwsConfig() {
    return new Promise(((resolve, reject) => {
      AWS.config.getCredentials(async (err) => {
        if (err) {
          toast.error(err && err.message);
          // eslint-disable-next-line prefer-promise-reject-errors
          return reject(undefined);
        }
        return resolve(AWS.config.credentials);
      });
    }));
  }

s3SelectQuery = async (query, fileName, bucketPath) => {
  const key = `cognito-idp.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`;

  AWS.config.update({
    region: process.env.REACT_APP_REGION,
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
      Logins: {
        [key]: Auth.getInstance().getIDToken()
      }
    })
  });
  const credentials = await this.getAwsConfig();
  try {
    if (credentials) {
      const s3 = new AWS.S3({
        apiVersion: '2006-03-01',
        accessKeyId: AWS.config.credentials.accessKeyId,
        secretAccessKey: AWS.config.credentials.secretAccessKey,
        sessionToken: AWS.config.credentials.sessionToken,
        region: getS3Region()
      });
      return new Promise(async (resolve, reject) => {
        let params = {
          Bucket: bucketPath || `${process.env.REACT_APP_S3PREFIX}uploads/dataset/aircraft`,
          Key: fileName || 'FAA-Aircraft-Char-Database-v2.csv',
          Expression: query,
          ExpressionType: 'SQL',
          InputSerialization: {
            CSV: {
              FieldDelimiter: ',',
              FileHeaderInfo: 'USE',
              RecordDelimiter: '\n',
              AllowQuotedRecordDelimiter: true
            },
            CompressionType: (fileName && fileName.endsWith('.tgz')) ? 'GZIP' : 'NONE'
          },
          OutputSerialization: {
            JSON: {
              RecordDelimiter: ','
            }
          }
        };
        s3.selectObjectContent(params, (err, data) => {
          if (err) { reject(err); }
          const resultData = [];
          if (data !== null) {
            for (const [keyValue, value] of Object.entries(data.Payload)) {
              if (keyValue && value.Records) {
                resultData.push(value.Records.Payload);
              }
            }
          }
          let payload = Buffer.concat(resultData).toString('utf8');
          payload = payload.replace(/,$/, '');
          try {
            return resolve(JSON.parse(`[${payload}]`));
          } catch (e) {
            reject(new Error(`Unable to convert S3 data to JSON object. S3 Select Query: ${params.Expression}`));
          }
        });
      });
    }
  } catch (err) {
    toast.error('Failed to read data');
    return null;
  }
}
}

const Service = new S3Select();

export default Service;
export { Service as S3Select };
